// Mock data for Nyhive Voice AI platform

export const pricingPlans = [
  {
    id: 1,
    name: 'Startup Test',
    price: '₹4.50',
    period: 'per minute',
    description: 'Perfect for startups testing Voice AI capabilities',
    features: [
      'Up to 1,000 minutes/month',
      'OpenAI real-time API access',
      'Natural voice conversations',
      'Basic analytics dashboard',
      'Email support',
      'API documentation'
    ],
    highlighted: false,
    ctaText: 'Start Free Trial'
  },
  {
    id: 2,
    name: 'Pro',
    price: '₹6',
    period: 'per minute',
    description: 'Everything in Startup Test, plus advanced features',
    features: [
      'Everything in Startup Test',
      'Up to 10,000 minutes/month',
      'Advanced voice customization',
      'Multi-language support',
      'Priority support',
      'Custom voice personas',
      'Advanced analytics',
      'Webhook integrations'
    ],
    highlighted: true,
    ctaText: 'Start Pro Trial'
  },
  {
    id: 3,
    name: 'Enterprise',
    price: '₹9',
    period: 'per minute',
    description: 'Everything in Pro, plus enterprise-grade features',
    features: [
      'Everything in Pro',
      'Unlimited minutes',
      'Dedicated account manager',
      'Custom AI model fine-tuning',
      'Advanced security & compliance',
      'Custom integrations',
      'SLA guarantee (99.9% uptime)',
      'White-label options',
      'Onboarding & training'
    ],
    highlighted: false,
    ctaText: 'Contact Sales'
  }
];

export const features = [
  {
    id: 1,
    title: 'Real-Time Voice AI',
    description: 'Powered by OpenAI\'s latest real-time APIs, delivering natural, intelligent conversations with minimal latency.',
    icon: 'Mic'
  },
  {
    id: 2,
    title: 'Natural Conversations',
    description: 'Best-in-class voice experience that understands context, tone, and intent for human-like interactions.',
    icon: 'MessageCircle'
  },
  {
    id: 3,
    title: 'Multi-Language Support',
    description: 'Communicate in 50+ languages with accurate speech recognition and natural voice synthesis.',
    icon: 'Globe'
  },
  {
    id: 4,
    title: 'Custom Voice Personas',
    description: 'Create unique voice personalities that match your brand identity and customer expectations.',
    icon: 'Users'
  },
  {
    id: 5,
    title: 'Enterprise Security',
    description: 'Bank-grade encryption, SOC 2 compliance, and data privacy controls built-in.',
    icon: 'Shield'
  },
  {
    id: 6,
    title: 'Easy Integration',
    description: 'Simple REST APIs and SDKs to integrate Voice AI into your existing applications in minutes.',
    icon: 'Zap'
  }
];

export const howItWorksSteps = [
  {
    id: 1,
    title: 'Sign Up & Configure',
    description: 'Create your account in seconds with Google login. Configure your voice preferences and select your AI model.',
    icon: 'UserPlus'
  },
  {
    id: 2,
    title: 'Integrate API',
    description: 'Use our simple REST API or SDK to integrate Voice AI into your application. Complete documentation provided.',
    icon: 'Code'
  },
  {
    id: 3,
    title: 'Go Live',
    description: 'Start delivering intelligent voice experiences to your customers. Monitor analytics and optimize performance.',
    icon: 'Rocket'
  }
];

export const testimonials = [
  {
    id: 1,
    name: 'Priya Sharma',
    role: 'CTO, HealthTech Solutions',
    content: 'Nyhive\'s Voice AI transformed our patient support system. The natural conversations are incredible!',
    avatar: 'PS'
  },
  {
    id: 2,
    name: 'Rahul Mehta',
    role: 'Founder, EdTech Startup',
    content: 'Best Voice AI platform we\'ve used. The pricing is startup-friendly and the quality is enterprise-grade.',
    avatar: 'RM'
  },
  {
    id: 3,
    name: 'Sneha Patel',
    role: 'Product Lead, FinTech Corp',
    content: 'OpenAI real-time APIs through Nyhive deliver the most natural voice experience for our customers.',
    avatar: 'SP'
  }
];

export const mockNewsletterSubscribe = (email) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log('Newsletter subscription:', email);
      resolve({ success: true, message: 'Successfully subscribed to newsletter!' });
    }, 1000);
  });
};

export const mockContactSubmit = (data) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log('Contact form submission:', data);
      resolve({ success: true, message: 'Message sent successfully! We\'ll get back to you soon.' });
    }, 1000);
  });
};

export const mockLogin = (email) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log('Login attempt:', email);
      resolve({ success: true, user: { email, name: 'Demo User' } });
    }, 1000);
  });
};